import { useCallback, useEffect, useRef, useState } from "react";

/** Open until a press lands outside it, or Escape. */
export function useFoldAway() {
  const rootRef = useRef<HTMLDivElement>(null);
  const [unfolded, setUnfolded] = useState(false);
  const toggle = useCallback(() => setUnfolded((current) => !current), []);
  useEffect(() => {
    if (!unfolded) {
      return;
    }
    const onPress = (event: PointerEvent): void => {
      if (!rootRef.current?.contains(event.target as Node)) {
        setUnfolded(false);
      }
    };
    const onKey = (event: KeyboardEvent): void => {
      if (event.key === "Escape") {
        setUnfolded(false);
      }
    };
    window.addEventListener("pointerdown", onPress);
    window.addEventListener("keydown", onKey);
    return () => {
      window.removeEventListener("pointerdown", onPress);
      window.removeEventListener("keydown", onKey);
    };
  }, [unfolded]);
  return { rootRef, unfolded, toggle };
}
